/* global google */
export default async function (input) {
  const service = google.maps.places.AutocompleteSuggestion
  const params = {
    input
  }

  const response = await service.fetchAutocompleteSuggestions(params)

  if (!response || !response.suggestions || response.suggestions.length === 0) {
    return []
  }

  const filteredSuggestions = await Promise.all(
    response.suggestions
      .filter(suggestion => suggestion.placePrediction)
      .map(async suggestion => {
        const place = suggestion.placePrediction.toPlace()

        if (!place) return null

        await place.fetchFields({
          fields: ['formattedAddress', 'id']
        })

        return {
          name: place.formattedAddress,
          value: place.id
        }
      })
  )

  return filteredSuggestions.filter(suggestion => suggestion !== null)
}
